<div class="content w-full h-full bg-(--comp-app-bg) flex flex-col">
  <div
    class="py-4 flex justify-center flex-col items-start px-4 lg:flex-row lg:justify-between gap-4 lg:h-21"
  >
    <app-tab-menu-simple
      class="w-[-webkit-fill-available]"
      [tabs]="taps"
      [indexSelected]="statusSelected"
      (changeSelected)="onStatusSelectedChange($event)"
      [titule]="'home.requestsMenuTitle' | translate"
    ></app-tab-menu-simple>

    @if (statusSelected != 2) {
      <div class="w-[-webkit-fill-available]">
        <div class="mx-4 flex gap-4 justify-end items-center">
          @if (statusSelected == 0) {
            <button
              (click)="openFilter()"
              class="button-alternative mb-4"
              matButton
              [matBadge]="cont"
              [matBadgeHidden]="cont === 0"
            >
              <div class="flex justify-center items-center gap-4">
                <span class="material-symbols-outlined"> page_info </span>
                {{ 'common.actions.filter' | translate }}
              </div>
            </button>

            <app-input-general
              [placeholder]="'home.searchByIdPlaceholder'"
              [formControlGeneral]="SearchFieldValue"
            ></app-input-general>
          }

          @if (statusSelected == 1) {
            <app-input-general
              class="min-w-70"
              [label]="''"
              [placeholder]="'common.actions.search'"
              [formControlGeneral]="search"
            ></app-input-general>
          }
        </div>
      </div>
    }
  </div>
  @if (statusSelected == 0) {
    <app-locations></app-locations>
  }
  @if (statusSelected == 1) {
    <app-my-requests> </app-my-requests>
  }
  @if (statusSelected == 2) {
    <app-high-request></app-high-request>
  }
</div>
